.formField {
  position: relative;

  aside {
    position: absolute;
    left: 1.5rem;
    z-index: 4;
    top: 50%;
    margin-top: -0.75rem;

    svg {
      width: 1.5rem;
    }
  }

  aside ~ input {
    padding-left: 3.5rem;
  }
}

.errorIcon {
  fill: var(--color-error-darker);
}

.warningIcon {
  fill: var(--color-warning);
}
